import apis from "../../core/apis.js";

class PaymentCycleConfigurationsResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  get(id) {
    return this.$resource(apis.paymentCycleConfigurations + "city/" + id).get();
  }

  post(item) {
    return this.$resource(apis.paymentCycleConfigurations).save(item);
  }

  update(id, item) {
    return this.$resource(apis.paymentCycleConfigurations + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }
}

export default PaymentCycleConfigurationsResource;



// WEBPACK FOOTER //
// ./src/resources/paymentCycleConfigurations/paymentCycleConfigurations.resource.js